import styled from "@emotion/styled";
import { theme } from "styles/theme";

// MonthPicker
export const MonthPickerWrapper = styled.div`

.react-datepicker{
  padding : 16px;
  width: fit-content;
  height: fit-content;
  border: none;
  border-radius: 15px;
  box-shadow: 0px 4px 20px 0px rgba(00, 00, 00, 0.15);

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__month-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .react-datepicker__header {
    padding: 0;
    background-color: #fff;
    color: #fff;
    border-bottom: none;
    border-radius: 0;    
  }

  .react-datepicker__month-container {
    .react-datepicker__month {
      margin : 0px;
    }

    .react-datepicker__month-text {
      box-sizing: border-box;
      padding: 10px 26px;
      width: 85px;

      color: var(--alias-color-label-neutral);
      font-size: 15px;
      font-weight: 500;
    }

    .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
      background-color: #fff;
    }

    .react-datepicker__month-text--selected {
      background-color: var(--alias-color-primary-normal);
      
      color: white;
      font-weight: 700;
    }

    .react-datepicker__month-text--disabled {
      background-color: var(--alias-color-interaction-disabled);
      border-radius: 6px;
      color: var(--alias-color-label-disabled);
    }
  }
}`;